import React from 'react';
import BusinessCardItem from './BusinessCardItem';
import { Divider } from 'antd';
import TitleText from '../atoms/TitleText';

type BusinessCardInfoProps = {
  title: string;
  payload?: {
    items?: Array<{
      text: string;
      value: React.ReactNode;
      code?: string;
      isEdited?: boolean;
    }>;
  };
  isStatus?: boolean;
};

const BusinessCardInfo = ({
  title,
  payload,
  isStatus,
}: BusinessCardInfoProps) => {
  return (
    <>
      <div className="body-card flex flex-col gap-4 py-2">
        <TitleText text={title} size="base" className="!font-bold !leading-6" />
        <div className="body-card-grid flex flex-col">
          {payload?.items?.map((item, index) => (
            <div key={index}>
              <BusinessCardItem
                isStatus={isStatus && index === 0}
                text={item?.text}
                value={item?.value}
                code={item?.code}
                isEdited={item?.isEdited}
              />
              {index < (payload?.items?.length ?? 0) - 1 && (
                <Divider className="my-2" />
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BusinessCardInfo;
